import { CcyPairLookupService } from "../../model/impl/CcyPairLookupService";
import { PricingServiceMode } from "../PricingService";
import { RateCache } from "../../../rate/impl/RateCache";
import { TraderGroupLookupService } from "../../../lookup/model/impl/TraderGroupLookupService";
import { UserTemperatureService } from "../../../profile/impl/UserTemperatureService";
import { Injectable } from "@angular/core";
import { PricingService } from "../PricingService";
import { TranslateService } from "@ngx-translate/core";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BasePricingService extends PricingService {
  constructor(
    myTraderGroupLookup: TraderGroupLookupService,
    public ccyPairLookupService: CcyPairLookupService,
    rateCache: RateCache,
    userTemperature: UserTemperatureService,
    _translationService: TranslateService,
  ) {
    super(
      ccyPairLookupService,
      myTraderGroupLookup,
      rateCache,
      userTemperature,
      PricingServiceMode.BASE,
      _translationService,
    );
  }
}
